import { Loader2 } from 'lucide-react'

export function Loading({ label = 'Opening the kitchen' }: { label?: string }) {
  return (
    <div
      role="status"
      className="grid flex-1 place-content-center justify-items-center gap-3 p-10 text-center"
    >
      <Loader2
        aria-hidden="true"
        className="size-6 animate-spin text-brand motion-reduce:animate-none"
      />
      <p className="text-sm font-semibold text-ink-soft">{label}</p>
    </div>
  )
}
